import {NgModule} from "@angular/core";
import {EnterByTokenComponent} from "./enter.by.token.component";
import {BrowserModule} from "@angular/platform-browser";
import {ReactiveFormsModule, FormsModule} from '@angular/forms';
import {RouterModule} from "@angular/router";
import {AuthService} from "../../models/auth/auth.service";

@NgModule({
    declarations: [EnterByTokenComponent],
    imports     : [
        BrowserModule,
        ReactiveFormsModule,
        RouterModule,
        FormsModule,
    ],
    providers: [
        AuthService,
    ]
})

export class EnterByTokenModule {}


// WEBPACK FOOTER //
// ./src/app/views/enter-by-token/enter.by.token.module.ts